export const downloadFile = (downloadUrl: string) => {
  const a = document.createElement("a")
  a.href = downloadUrl
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}

/**
 * 将一个对象中的某几个key去除， key应该支持点语法
 * 比如obj = {a: {b: 1, d:3}, c: 2}
 * 比如keys = ["a.b", "c"]
 * 结果为 {a: {d:3}, c: 2}
 * @param obj 要处理的对象
 * @param keys 要去除的key数组
 * @param config 配置项
 *   inplace 是否修改原对象
 * @returns 处理后的对象
 */
export const removeKeysDeep = <T extends Record<string, any>>(
  obj: T,
  keysToRemove: string[],
  {
    inplace = false,
  }: {
    inplace?: boolean
  }
): T => {
  if (!obj || typeof obj !== "object") {
    return obj
  }

  const targetObj: T = inplace ? obj : { ...obj }

  keysToRemove.forEach(keyPath => {
    const pathParts = keyPath.split(".")
    let current: any = targetObj
    let parent: any = null
    let lastPart: string = ""

    for (let i = 0; i < pathParts.length; i++) {
      const part = pathParts[i]
      if (i === pathParts.length - 1) {
        lastPart = part
        break
      }
      if (current && typeof current === "object" && current.hasOwnProperty(part)) {
        parent = current
        current = current[part]
      } else {
        // Path does not exist or intermediate part is not an object, stop traversing
        current = null
        break
      }
    }

    if (current && typeof current === "object" && current.hasOwnProperty(lastPart)) {
      if (parent) {
        if (inplace) {
          delete parent[lastPart]
        } else {
          // If it's a nested key, create a new object for the parent to maintain immutability
          const newParent = { ...parent }
          delete newParent[lastPart]
          // Update the reference in the targetObj structure
          let tempObj: any = targetObj
          for (let i = 0; i < pathParts.length - 1; i++) {
            const part = pathParts[i]
            if (tempObj.hasOwnProperty(part)) {
              tempObj[part] = { ...tempObj[part] } // Ensure immutability up the chain
              tempObj = tempObj[part]
            } else {
              break
            }
          }
          tempObj[pathParts[pathParts.length - 2]] = newParent
        }
      } else {
        // Top-level key
        delete targetObj[lastPart]
      }
    } else if (targetObj.hasOwnProperty(keyPath)) {
      // Handle direct top-level keys that might not be part of a path
      delete targetObj[keyPath]
    } else {
      console.warn(`Key path '${keyPath}' not found in object.`)
    }
  })

  return targetObj
}
